import React, { memo, useMemo } from 'react';
import { Popup } from 'react-map-gl';
import { makeStyles } from '@mui/styles';

import { Text, View } from '../Base';
import { CloseIcon } from '../icons';
import arrowPopup from '../../assets/arrowPopup.svg';
import palette from '../styles/palette';
import StopMarkerWithPopover from '../Markers/StopMarker/StopMarkerWithPopover';

const useStyles = makeStyles({
  popup: {
    color: palette.typography.white.solid,
    zIndex: '4 !important',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '& .mapboxgl-popup-tip': {
      border: 'none',
      width: '18px',
      height: '28px',
      backgroundImage: `url(${arrowPopup})`,
      transform: 'rotate(-90deg)',
      bottom: '-23px',
      position: 'absolute',
    },
    '& .mapboxgl-popup-content': {
      background: 'transparent',
      padding: '0px !important',
      cursor: 'default',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  popupContainer: {
    borderRadius: '8px',
    maxWidth: '260px',
    padding: '10px',
    background: palette.typography.black.high,
    display: 'flex',
    flexDirection: 'column',
  },
  popupHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '21px',
    letterSpacing: '0.02em',
    alignItems: 'center',
  },
  headerButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  closeIcon: {
    height: '16px',
    width: '16px',
    cursor: 'pointer',
  },
  popupContext: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px 0 10px 0',
    '& .MuiBadge-root': {
      margin: '10px 0 0 10px',
    },
  },
});

const ClusterPopup = ({ coordinates, onClose, stop: feature, clusterRef }) => {
  const styles = useStyles();
  const stopPoints = useMemo(() => {
    try {
      const points = clusterRef.getLeaves(
        feature.properties.cluster_id,
        1000,
        0
      );
      return points;
    } catch {
      onClose();
    }
  }, [clusterRef, feature, onClose]);

  return (
    <Popup
      longitude={coordinates[0]}
      latitude={coordinates[1]}
      anchor={'bottom'}
      offset={[0, -65]}
      className={styles.popup}
      closeButton={false}
      closeOnClick={false}
      maxWidth="none"
    >
      <View className={styles.popupContainer}>
        <View className={styles.popupHeaderContainer}>
          <Text>{`${feature.properties.point_count} Stops`}</Text>
          <View className={styles.headerButtonContainer}>
            <CloseIcon onClick={onClose} className={styles.closeIcon} />
          </View>
        </View>
        <View className={styles.popupContext}>
          {stopPoints.map((stop, index) => (
            <StopMarkerWithPopover key={index} stop={stop} />
          ))}
        </View>
      </View>
    </Popup>
  );
};

export default memo(ClusterPopup);
